export default {"src":"/_next/static/media/temus.9fe13920.svg","height":22,"width":75,"blurWidth":0,"blurHeight":0};